import { render } from "./WelcomeChangeImage.vue?vue&type=template&id=7d903760"
import script from "./WelcomeChangeImage.vue?vue&type=script&lang=js"
export * from "./WelcomeChangeImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__